import React, { useEffect, useState } from 'react'
import { setUserPreferredFontSize } from '../../store/actions/user'
import { useAppDispatch, useAppSelector } from '../../store/reducers/store'
import './Header.sass'
import Waves from './Waves'

interface HeaderProps {
    title: string
    hideUserInfo?: boolean
}

const Header: React.FC<HeaderProps> = (props) => {
    const data = useAppSelector((data) => data.data)
    const user = useAppSelector((data) => data.user)

    const [animatedHeader, setAnimatedHeader] = useState(data.currentInstance?.keys?.graphics.animated_header || false)

    useEffect(() => {
        setAnimatedHeader(data.currentInstance?.keys?.graphics.animated_header || false)
    }, [data.currentInstance?.keys?.graphics.animated_header])
    const dispatch = useAppDispatch()

    const changeFontSize = (operator: '-' | '+') => {
        const starter = user.userPreferredFontSize || 14
        const calc = operator === '+' ? starter + 2 : starter - 2
        document.documentElement.style.setProperty('--font-size', `${calc.toString()}px`)
        dispatch(setUserPreferredFontSize(calc))
    }

    return (
        <>
            {animatedHeader ? <Waves /> : null}

            <div className="main-header" style={{ height: animatedHeader ? '10%' : '8%' }}>
                <div className="main-header__top-section">
                    <span className="main-header__top-section__title">
                        {data.currentInstance?.keys?.graphics.hide_title ? '' : props.title}
                    </span>
                    <div className="main-header__top-section__font-size">
                        <div
                            className={`font-change-button ${
                                user.userPreferredFontSize === 10 ? 'disabled-font-size-button' : ''
                            }`}
                            onClick={() => {
                                if (user.userPreferredFontSize === 10) return
                                changeFontSize('-')
                            }}
                        >
                            <span className="decrease">A</span>
                        </div>
                        <div
                            className={`font-change-button ${
                                user.userPreferredFontSize === 20 ? 'disabled-font-size-button' : ''
                            }`}
                            onClick={() => {
                                if (user.userPreferredFontSize === 20) return
                                changeFontSize('+')
                            }}
                        >
                            <span className="increase">A</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Header
